import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

import { UrlManageService } from '../services/url-manage.service';
import { GraphSearchServiceService } from '../services/graph-search-service.service'
import { IfStmt } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})





export class GraphVisualServiceService {

  constructor(
    private http: HttpClient,
    private urlList: UrlManageService,
    private graphSearchService: GraphSearchServiceService
  ) { }

  searchData;
  searchResult;

  getGraphVisualData(flag, data) {
    if (flag == "graph") {
      this.searchData = this.graphSearchService.getGraphSearchValue()
      const param = new HttpParams({
        fromObject: this.searchData
      })
      if (this.searchData.startNode.label == 'all') {
        this.searchData.startNode.label = ''
      }
      if (this.searchData.relationship.label == 'all') {
        this.searchData.relationship.label = ''
      }
      if (this.searchData.endNode.label == 'all') {
        this.searchData.endNode.label = ''
      }
      return this.http.post(this.urlList.searchPath, this.searchData)
    }
    else if (flag == "detail") {
      return this.http.get(this.urlList.getProteinGraph + data)
    }

  }


  downloadGraphVisualData(data){
    this.searchData = this.graphSearchService.getGraphSearchValue()
      const param = new HttpParams({
        fromObject: this.searchData
      })
      if (this.searchData.startNode.label == 'all') {
        this.searchData.startNode.label = ''
      }
      if (this.searchData.relationship.label == 'all') {
        this.searchData.relationship.label = ''
      }
      if (this.searchData.endNode.label == 'all') {
        this.searchData.endNode.label = ''
      }
      return this.http.post(this.urlList.downloadPath, this.searchData, {responseType: "blob"})
  }




}
